import { extendObservable } from 'mobx'

export default class Metric {
  constructor (metricData) {
    extendObservable(this, {
      loading: false,
      error: null,
      average: null,
      firstSubmit: null,
      lastSubmit: null,
      ...metricData
    })
  }
}
